<template>
	<div class="graph-nd graph-1d status-graph">
		<svg :viewBox="'0 0 ' + width + ' ' + height" xmlns="http://www.w3.org/2000/svg">
			<Legend v-bind:width="width"
				v-bind:height="height"
				v-bind:startDate="startDate"
				v-bind:bins="bins.length"
				v-bind:binWidth="binWidth">
			</Legend>

			<g v-for="(bin, index) in bins" :key="index"
				class="tooltip-trigger"
				@click="showTooltip(bin, ...arguments)"
				@mouseover="showTooltip(bin, ...arguments)"
				@mouseout="hideTooltip">

				<div v-if="bin.length > 0"
					:is="statusIcon(bin[0].status)"
					:x="centerScaleX(index) - style.pointRadius"
					:y="height / 2 - 40"
					:width="style.pointRadius * 2"
					:height="style.pointRadius * 2"
					@mouseover="showTooltip"
					@mouseout="hideTooltip"></div>

			</g>
		</svg>

		<Tooltip v-bind:display="tooltipDisplay" @hover="hoverTooltip" :width="120">
			<p v-if="tooltipBin.length > 0">
				<strong class="capitalize">{{ tooltipBin[0].status.replace(/\_/g, ' ') }}</strong><br>
				<small>{{ formatDate(tooltipBin[0].time - (7 * oneDay)) }} - {{ formatDate(tooltipBin[0].time) }}</small>
			</p>
		</Tooltip>
	</div>
</template>

<script>
import Graph from '.'
import Legend from './component/Legend'

// import AlwaysStatusIcon from './icon/AlwaysStatusIcon'
// import SometimesStatusIcon from './icon/SometimesStatusIcon'
// import NeverStatusIcon from './icon/NeverStatusIcon'

export default {
	name: 'status-graph-1d',
	extends: Graph,

	computed: {
		/**
		 * @function 	bins
		 * @desc 		Bins the data points into day-wide bins for the interval determined by the current scale
		 */
		bins() {
			var bins = []

			for (var t = this.startDate.getTime() ; t <= this.date.getTime() ; t += this.binInterval) {
				bins.push(this.data.filter((point) => (t <= point.time && point.time <= t + this.binInterval)))
			}

			bins = bins.map((bin) => {
				if (bin.length > 1) {
					let max = 0, i = 1
					for (; i < bin.length ; i++) {
						if (bin[max].time < bin[i].time)
							max = i
					}
					bin = [ bin[max] ]
				}
				return bin
			})

			return bins
		},

		/**
		 * @function 	legendStart
		 * @desc 		first x-axis point to plot value at
		 */
		legendStart() {
			return this.height - this.style.padding * 2 - this.style.legendHeight
		},
		interval() {
			return this.date.getTime() - this.startDate.getTime()
		},
		binInterval() {
			return this.oneDay * this.binWidth
		}
	},
	methods: {
		setScale(scale) {
			this.scale = scale
		},
		scaleX(x) {
			return x * this.width / this.bins.length
		},
		centerScaleX(x) {
			return (x + 0.5) * this.width / (this.bins.length + 1)
		},
		next() {
			var now = new Date()
			this.date = new Date(this.date.getTime() + this.interval + (this.intevalGap * this.intervalDays))
			if (this.date.getTime() > now.getTime()) {
				this.date = now
			}
		},
		previous() {
			this.date = new Date(this.date.getTime() - this.interval - (this.intevalGap * this.intervalDays))
		},
		binDate(index) {
			return new Date(this.startDate.getTime() + this.binInterval * index)
		},
		statusIcon(status) {
			return 'div'
			// if (status == 'always')
			// 	return 'AlwaysStatusIcon'
			// if (status == 'sometimes' || status == 'missed_a_few')
			// 	return 'SometimesStatusIcon'
			// if (status == 'never')
			// 	return 'NeverStatusIcon'
		}
	},
	components: {
		Legend,

		// Status icons
		// AlwaysStatusIcon,
		// SometimesStatusIcon,
		// NeverStatusIcon
	}
}
</script>

<style lang="scss" scoped>
.graph-1d {
	background-color: #ffffff;
	position: relative;
}
</style>
